export const STORAGE_KEYS = {
  PATTERN: 'mosaic_pattern',
  SELECTED_STITCH: 'mosaic_selectedStitch',
  SELECTED_COLOR: 'mosaic_selectedColor',
  ACTIVE_TOOL: 'mosaic_activeTool',
  SELECTED_VARIANTS: 'mosaic_selectedVariants',
  LANGUAGE: 'mosaic_language',
} as const;

export const MAX_HISTORY = 100;
